// Real readings from Gallivant RP, nothing invented; the home page shows them
// as a dated record, never as live data (TOM-552).
//
// The evening: 6 September 2026, 7:20 PM PDT (02:20Z on the 7th), at anchor in
// British Columbia, and the night to 8:00 AM. Gallivant sat well inside her
// anchor circle all along (at most 53% of it from the watch to 7:20 PM, 33%
// overnight), so Neo's status rules would say what the scene says (sceneStatus.ts).
// - Positions and every reading: the export of her InfluxDB on the 30-second grid
//   (cloud/scripts/influx-export.ts, ADR 0227), at 02:20:00Z, 03:00:00Z (8 PM)
//   and 15:00:00Z (8 AM).
// - The anchor watch's circle, her distance and bearing from the anchor, and true
//   wind: the eval moments' 5-minute tier (cloud/src/core/neo/eval/moments,
//   gallivant-2026-09-07T1250Z and -09-08T1500Z, ADR 0214/0236); her InfluxDB
//   holds no anchor watch. The circle is first recorded in the 3:45 PM bucket.
// - The anchor: the median of 37 estimates (her mean position each 5 minutes,
//   moved back along the bearing by the distance), which agree within about
//   2 m from 4:55 PM on.
// Engine: tests/fixtures/engine-logbook/manifest.json, the 5 September starboard run.
// Water: cloud/scripts/water-backtest.md (tank capacity 1703.4 L).

export type LatLon = { lat: number; lon: number };

export const GALLIVANT_AT = '2026-09-07T02:20:00.000Z';
export const GALLIVANT_ZONE = 'America/Vancouver';
export const GALLIVANT_ANCHOR: LatLon = { lat: 50.134296, lon: -124.925028 };
export const GALLIVANT_BOAT: LatLon = { lat: 50.134403, lon: -124.924824 };
/** Every stored fix from the anchor watch until 7:20 PM (431, 30 s apart), every third. */
export const GALLIVANT_TRACK: LatLon[] = [
  { lat: 50.134192, lon: -124.924957 },
  { lat: 50.134172, lon: -124.924868 },
  { lat: 50.134195, lon: -124.92483 },
  { lat: 50.134213, lon: -124.924872 },
  { lat: 50.13423, lon: -124.924874 },
  { lat: 50.134211, lon: -124.924911 },
  { lat: 50.134201, lon: -124.924895 },
  { lat: 50.134175, lon: -124.924939 },
  { lat: 50.134156, lon: -124.924946 },
  { lat: 50.134161, lon: -124.924975 },
  { lat: 50.134171, lon: -124.924979 },
  { lat: 50.134188, lon: -124.924983 },
  { lat: 50.134206, lon: -124.924999 },
  { lat: 50.134185, lon: -124.924968 },
  { lat: 50.134177, lon: -124.924935 },
  { lat: 50.134171, lon: -124.924949 },
  { lat: 50.134182, lon: -124.924921 },
  { lat: 50.13418, lon: -124.924936 },
  { lat: 50.134174, lon: -124.924948 },
  { lat: 50.134189, lon: -124.924964 },
  { lat: 50.134192, lon: -124.924947 },
  { lat: 50.134187, lon: -124.924914 },
  { lat: 50.134187, lon: -124.92489 },
  { lat: 50.134192, lon: -124.924886 },
  { lat: 50.134201, lon: -124.92489 },
  { lat: 50.134213, lon: -124.924854 },
  { lat: 50.134222, lon: -124.924856 },
  { lat: 50.134228, lon: -124.924854 },
  { lat: 50.134223, lon: -124.924864 },
  { lat: 50.13423, lon: -124.924856 },
  { lat: 50.134218, lon: -124.924847 },
  { lat: 50.134212, lon: -124.924862 },
  { lat: 50.134217, lon: -124.924884 },
  { lat: 50.134224, lon: -124.924898 },
  { lat: 50.134236, lon: -124.92489 },
  { lat: 50.13424, lon: -124.924869 },
  { lat: 50.134218, lon: -124.924856 },
  { lat: 50.134192, lon: -124.924865 },
  { lat: 50.134207, lon: -124.924891 },
  { lat: 50.134219, lon: -124.924908 },
  { lat: 50.134231, lon: -124.924865 },
  { lat: 50.134225, lon: -124.924883 },
  { lat: 50.134227, lon: -124.924829 },
  { lat: 50.134233, lon: -124.924769 },
  { lat: 50.134251, lon: -124.924754 },
  { lat: 50.134278, lon: -124.924775 },
  { lat: 50.134301, lon: -124.924755 },
  { lat: 50.134327, lon: -124.924734 },
  { lat: 50.134316, lon: -124.924746 },
  { lat: 50.134298, lon: -124.924778 },
  { lat: 50.134254, lon: -124.924807 },
  { lat: 50.134213, lon: -124.924812 },
  { lat: 50.134177, lon: -124.924856 },
  { lat: 50.134187, lon: -124.924918 },
  { lat: 50.13419, lon: -124.924952 },
  { lat: 50.134183, lon: -124.924969 },
  { lat: 50.134178, lon: -124.924982 },
  { lat: 50.134183, lon: -124.924997 },
  { lat: 50.134207, lon: -124.925011 },
  { lat: 50.134209, lon: -124.925001 },
  { lat: 50.134192, lon: -124.924952 },
  { lat: 50.134189, lon: -124.924955 },
  { lat: 50.134174, lon: -124.924946 },
  { lat: 50.134186, lon: -124.924958 },
  { lat: 50.134205, lon: -124.924965 },
  { lat: 50.134204, lon: -124.924994 },
  { lat: 50.134202, lon: -124.925023 },
  { lat: 50.134208, lon: -124.925042 },
  { lat: 50.134227, lon: -124.925037 },
  { lat: 50.134237, lon: -124.925044 },
  { lat: 50.134239, lon: -124.925057 },
  { lat: 50.134239, lon: -124.925074 },
  { lat: 50.134237, lon: -124.925109 },
  { lat: 50.134244, lon: -124.925122 },
  { lat: 50.134248, lon: -124.925102 },
  { lat: 50.134255, lon: -124.925087 },
  { lat: 50.134257, lon: -124.925088 },
  { lat: 50.134265, lon: -124.925077 },
  { lat: 50.134245, lon: -124.925091 },
  { lat: 50.134246, lon: -124.925072 },
  { lat: 50.134241, lon: -124.92505 },
  { lat: 50.134231, lon: -124.925034 },
  { lat: 50.134223, lon: -124.925021 },
  { lat: 50.134224, lon: -124.924995 },
  { lat: 50.134212, lon: -124.924991 },
  { lat: 50.134205, lon: -124.924984 },
  { lat: 50.134206, lon: -124.924954 },
  { lat: 50.134203, lon: -124.924964 },
  { lat: 50.134199, lon: -124.924951 },
  { lat: 50.134212, lon: -124.924947 },
  { lat: 50.134212, lon: -124.924924 },
  { lat: 50.13422, lon: -124.924907 },
  { lat: 50.134222, lon: -124.924897 },
  { lat: 50.134222, lon: -124.924871 },
  { lat: 50.134225, lon: -124.924849 },
  { lat: 50.134235, lon: -124.924808 },
  { lat: 50.134262, lon: -124.924789 },
  { lat: 50.134289, lon: -124.924768 },
  { lat: 50.134315, lon: -124.924764 },
  { lat: 50.13433, lon: -124.924782 },
  { lat: 50.134356, lon: -124.924771 },
  { lat: 50.134363, lon: -124.924769 },
  { lat: 50.134351, lon: -124.924772 },
  { lat: 50.134349, lon: -124.924776 },
  { lat: 50.134356, lon: -124.924771 },
  { lat: 50.134349, lon: -124.92477 },
  { lat: 50.134357, lon: -124.924782 },
  { lat: 50.134359, lon: -124.924787 },
  { lat: 50.134367, lon: -124.924794 },
  { lat: 50.134375, lon: -124.924792 },
  { lat: 50.134385, lon: -124.924795 },
  { lat: 50.13439, lon: -124.924818 },
  { lat: 50.134395, lon: -124.92483 },
  { lat: 50.134395, lon: -124.924853 },
  { lat: 50.1344, lon: -124.924868 },
  { lat: 50.134401, lon: -124.924881 },
  { lat: 50.134406, lon: -124.924879 },
  { lat: 50.134408, lon: -124.924868 },
  { lat: 50.134414, lon: -124.924859 },
  { lat: 50.13441, lon: -124.924852 },
  { lat: 50.134409, lon: -124.924846 },
  { lat: 50.134393, lon: -124.924853 },
  { lat: 50.134382, lon: -124.924844 },
  { lat: 50.134379, lon: -124.924835 },
  { lat: 50.134382, lon: -124.924816 },
  { lat: 50.134391, lon: -124.92481 },
  { lat: 50.134395, lon: -124.924819 },
  { lat: 50.134386, lon: -124.924824 },
  { lat: 50.134393, lon: -124.924818 },
  { lat: 50.134382, lon: -124.924825 },
  { lat: 50.134387, lon: -124.92483 },
  { lat: 50.134376, lon: -124.924828 },
  { lat: 50.134385, lon: -124.924808 },
  { lat: 50.134383, lon: -124.924799 },
  { lat: 50.134375, lon: -124.924819 },
  { lat: 50.134382, lon: -124.924803 },
  { lat: 50.134378, lon: -124.924795 },
  { lat: 50.134369, lon: -124.92479 },
  { lat: 50.134371, lon: -124.924804 },
  { lat: 50.13438, lon: -124.924823 },
  { lat: 50.134383, lon: -124.924819 },
  { lat: 50.134382, lon: -124.924819 },
  { lat: 50.134383, lon: -124.92482 },
  { lat: 50.134403, lon: -124.924813 },
  { lat: 50.134403, lon: -124.924824 },
];

/** Readings at 7:20 PM on 6 September. */
export const GALLIVANT_EVENING = {
  /** The start of the 5-minute bucket the watch's circle is first recorded in. */
  anchorWatchSince: '2026-09-06T22:45:00.000Z',
  anchorRadiusM: 64.9,
  /** From the anchor to her fix at 7:20 PM (the tier's 7:15–7:20 mean is 16.3 m). */
  distanceFromAnchorM: 18.8,
  /** The most she was from the anchor between the watch and 7:20 PM. */
  maxDistanceSinceWatchM: 35.5,
  depthM: 14.9,
  /** True wind, the 7:15–7:20 PM mean. */
  windSpeedKn: 2.2,
  windFromDeg: 197,
  speedOverGroundKn: 0.02,
  headingDeg: 227,
  houseSocPct: 83,
  houseVoltage: 26.65,
  freshWaterPct: 94.9,
  airTempC: 19.2,
  waterTempC: 20.3,
  pressureHpa: 1015,
};

/** Readings for the 8:00 AM report on 7 September, over the night from 8:00 PM. */
export const GALLIVANT_MORNING = {
  at: '2026-09-07T15:00:00.000Z',
  maxDistanceFromAnchorM: 21.0,
  /** The smallest the watch's circle was overnight (it is re-set as the tide moves). */
  minAnchorRadiusM: 63.11,
  houseSocPct: 65,
  houseSocAt8pmPct: 81,
  solarW: 30,
  freshWaterPct: 93.4,
  freshWaterAt8pmPct: 94.9,
  /** True wind, the most of any 5 minutes. */
  maxWindKn: 7.3,
  pressureFromHpa: 1016,
  pressureToHpa: 1019,
  bilgeHighWaterTrips: 0,
};

/** The boat's own bilge high-water switches, by their channel labels. */
export const GALLIVANT_BILGE_SWITCHES = [
  'Engine room bilge high water',
  'Mid bilge high water',
  'Tank room bilge high water',
  'Laz bilge high water',
  'Bulb bilge high water',
];

export const GALLIVANT_FRESH_WATER_CAPACITY_L = 1703.4;

/** The 5 September starboard engine run (Volvo Penta D9). */
export const GALLIVANT_ENGINE_RUN = {
  engine: 'Starboard',
  startedAt: '2026-09-05T14:06:24.000Z',
  endedAt: '2026-09-05T21:30:50.000Z',
  hours: 7.4,
  coolantMaxC: 89,
  fuelL: 155,
  counterHours: 2664.75,
};

/** 48 hours to 7:20 PM on 6 September, 30-minute means: [unix seconds, value]. */
export const GALLIVANT_HOUSE_SOC: [number, number][] = [
  [1788574800, 95.5],
  [1788576600, 94.7],
  [1788578400, 94.0],
  [1788580200, 93.1],
  [1788582000, 91.9],
  [1788583800, 90.9],
  [1788585600, 90.1],
  [1788587400, 89.5],
  [1788589200, 88.9],
  [1788591000, 88.3],
  [1788592800, 87.7],
  [1788594600, 87.2],
  [1788596400, 86.6],
  [1788598200, 86.1],
  [1788600000, 85.5],
  [1788601800, 84.9],
  [1788603600, 84.3],
  [1788605400, 83.8],
  [1788607200, 83.2],
  [1788609000, 82.7],
  [1788610800, 82.1],
  [1788612600, 81.6],
  [1788614400, 81.0],
  [1788616200, 80.3],
  [1788618000, 80.5],
  [1788619800, 81.0],
  [1788621600, 81.6],
  [1788623400, 82.2],
  [1788625200, 82.9],
  [1788627000, 83.1],
  [1788628800, 83.4],
  [1788630600, 83.6],
  [1788632400, 83.6],
  [1788634200, 83.9],
  [1788636000, 84.3],
  [1788637800, 84.9],
  [1788639600, 85.4],
  [1788641400, 86.0],
  [1788643200, 86.0],
  [1788645000, 85.3],
  [1788646800, 84.7],
  [1788648600, 84.1],
  [1788650400, 83.4],
  [1788652200, 82.6],
  [1788654000, 81.9],
  [1788655800, 81.3],
  [1788657600, 82.1],
  [1788659400, 84.1],
  [1788661200, 84.5],
  [1788663000, 83.6],
  [1788664800, 82.8],
  [1788666600, 82.1],
  [1788668400, 81.4],
  [1788670200, 80.7],
  [1788672000, 80.0],
  [1788673800, 79.4],
  [1788675600, 78.8],
  [1788677400, 78.2],
  [1788679200, 77.6],
  [1788681000, 77.0],
  [1788682800, 76.5],
  [1788684600, 75.9],
  [1788686400, 75.3],
  [1788688200, 74.7],
  [1788690000, 74.1],
  [1788691800, 73.5],
  [1788693600, 73.0],
  [1788695400, 72.4],
  [1788697200, 71.8],
  [1788699000, 71.2],
  [1788700800, 70.6],
  [1788702600, 69.8],
  [1788704400, 68.8],
  [1788706200, 67.9],
  [1788708000, 67.5],
  [1788709800, 67.7],
  [1788711600, 68.1],
  [1788713400, 68.5],
  [1788715200, 69.3],
  [1788717000, 70.3],
  [1788718800, 71.2],
  [1788720600, 72.1],
  [1788722400, 72.9],
  [1788724200, 73.7],
  [1788726000, 75.1],
  [1788727800, 80.1],
  [1788729600, 85.5],
  [1788731400, 86.5],
  [1788733200, 85.6],
  [1788735000, 84.5],
  [1788736800, 83.8],
  [1788738600, 83.4],
  [1788740400, 82.6],
  [1788742200, 81.8],
  [1788744000, 82.3],
  [1788745800, 83.0],
];
export const GALLIVANT_FRESH_WATER_PCT: [number, number][] = [
  [1788574800, 63.6],
  [1788576600, 63.6],
  [1788578400, 63.6],
  [1788580200, 63.6],
  [1788582000, 63.5],
  [1788583800, 62.2],
  [1788585600, 62.2],
  [1788587400, 62.2],
  [1788589200, 62.2],
  [1788591000, 62.2],
  [1788592800, 62.2],
  [1788594600, 62.2],
  [1788596400, 62.2],
  [1788598200, 62.2],
  [1788600000, 62.2],
  [1788601800, 62.2],
  [1788603600, 62.2],
  [1788605400, 62.2],
  [1788607200, 62.2],
  [1788609000, 62.2],
  [1788610800, 62.2],
  [1788612600, 62.2],
  [1788614400, 62.2],
  [1788616200, 59.3],
  [1788618000, 58.4],
  [1788619800, 58.1],
  [1788621600, 57.7],
  [1788623400, 56.2],
  [1788625200, 58.3],
  [1788627000, 64.0],
  [1788628800, 69.6],
  [1788630600, 75.6],
  [1788632400, 80.4],
  [1788634200, 86.4],
  [1788636000, 92.7],
  [1788637800, 94.9],
  [1788639600, 92.1],
  [1788641400, 92.6],
  [1788643200, 93.4],
  [1788645000, 93.4],
  [1788646800, 93.4],
  [1788648600, 93.4],
  [1788650400, 93.4],
  [1788652200, 93.4],
  [1788654000, 93.4],
  [1788655800, 93.4],
  [1788657600, 93.4],
  [1788659400, 93.4],
  [1788661200, 93.4],
  [1788663000, 92.5],
  [1788664800, 91.9],
  [1788666600, 91.9],
  [1788668400, 91.9],
  [1788670200, 91.9],
  [1788672000, 91.9],
  [1788673800, 91.9],
  [1788675600, 91.9],
  [1788677400, 91.9],
  [1788679200, 91.9],
  [1788681000, 91.9],
  [1788682800, 92.0],
  [1788684600, 92.0],
  [1788686400, 91.9],
  [1788688200, 92.0],
  [1788690000, 91.9],
  [1788691800, 92.0],
  [1788693600, 92.0],
  [1788695400, 91.9],
  [1788697200, 91.9],
  [1788699000, 92.0],
  [1788700800, 92.0],
  [1788702600, 90.4],
  [1788704400, 89.0],
  [1788706200, 89.0],
  [1788708000, 88.9],
  [1788709800, 88.9],
  [1788711600, 83.7],
  [1788713400, 81.6],
  [1788715200, 80.3],
  [1788717000, 80.0],
  [1788718800, 78.1],
  [1788720600, 77.8],
  [1788722400, 78.5],
  [1788724200, 77.7],
  [1788726000, 77.7],
  [1788727800, 82.1],
  [1788729600, 88.2],
  [1788731400, 94.6],
  [1788733200, 96.4],
  [1788735000, 96.3],
  [1788736800, 96.3],
  [1788738600, 96.3],
  [1788740400, 95.0],
  [1788742200, 94.9],
  [1788744000, 94.9],
  [1788745800, 94.9],
];
